import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/mapPages/singleServiceCenter/SingleServiceCenterPage.tsx");
